import React, { useEffect, useState, useRef} from "react";
import axios from "axios";
import "./ManageEvents.css";


const ManageEvents = () => {
    const [events, setEvents] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editingEventId, setEditingEventId] = useState(null);
    const [newEvent, setNewEvent] = useState({

        title: "",
        description: "",
        date: "",
        location: "",
        embedMapLink: "",
        bannerImage: null,
        eventBoxImage: null,
        ticketImage: null,
        mobileBannerImage: null,
        checkInTime: "",
        startTime: "",
        endTime: "",
        priceClasses: [],
        termsAndConditions: "",
        status: "Active"

    });

    const [errorMessage, setErrorMessage] = useState("");
    const bannerInputRef = useRef(null);
    const eventBoxInputRef = useRef(null);
    const ticketInputRef = useRef(null);
    const mobileBannerInputRef = useRef(null);
    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/events`);
            setEvents(response.data);
        } catch (error) {
            console.error("Error fetching events:", error);
            setErrorMessage("❌ Failed to load events. Please try again later.");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;
        if (name === "date") {
            updatedValue = new Date(value).toLocaleDateString("en-CA");
        }
        setNewEvent({ ...newEvent, [name]: updatedValue });
    };
    const handlePriceClassesChange = (e, index, field) => {
        const updatedPriceClasses = [...newEvent.priceClasses];
        updatedPriceClasses[index] = { ...updatedPriceClasses[index], [field]: e.target.value };
        setNewEvent({ ...newEvent, priceClasses: updatedPriceClasses });
    };
    const handleAddPriceClass = () => {
        setNewEvent({
            ...newEvent,
            priceClasses: [...newEvent.priceClasses, { name: "", description: "", price: "", maxTickets: "", status: "Available"  }]
        });
    };
    const handleFileSelect = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            setNewEvent({ ...newEvent, [field]: file });
        }
    };
    const handleDrop = (e, field) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            setNewEvent({ ...newEvent, [field]: file });
        }
    };
    const handleCreateOrUpdateEvent = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        if (!newEvent.title.trim() || newEvent.title.length < 5) {
            setErrorMessage("Title is required and must be at least 5 characters long.");
            return;
        }
        if (!newEvent.description.trim() || newEvent.description.length < 10) {
            setErrorMessage("Description must be at least 10 characters long.");
            return;
        }
        if (!newEvent.date) {
            setErrorMessage("Event date is required.");
            return;
        }
        if (!newEvent.location.trim()) {
            setErrorMessage("Event location is required.");
            return;
        }
        if (!newEvent.embedMapLink.trim()) {
            setErrorMessage("Google Maps embed link is required.");
            return;
        }
        const formData = new FormData();
        Object.keys(newEvent).forEach(key => {
            if (key === "priceClasses") {
                formData.append(key, JSON.stringify(newEvent[key]));
            } else if (["bannerImage", "eventBoxImage", "ticketImage", "mobileBannerImage"].includes(key)) {
                if (newEvent[key] instanceof File) {
                    formData.append(key, newEvent[key]);
                } else if (typeof newEvent[key] === "string" && newEvent[key].startsWith("http")) {
                    formData.append(key, newEvent[key]);
                }
            } else if (newEvent[key]) {
                formData.append(key, newEvent[key]);
            }
        });
        try {
            let response;
            if (editingEventId) {
                response = await axios.put(`${process.env.REACT_APP_API_URL}/api/events/${editingEventId}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                alert("✅ Event updated successfully!");
            } else {
                response = await axios.post(`${process.env.REACT_APP_API_URL}/api/events`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                alert("✅ Event created successfully!");
            }

            fetchEvents();
            setShowForm(false);
        } catch (error) {
            console.error("❌ Error saving event:", error);
            if (error.response) {
                const errorMessage = error.response.data.error || "An error occurred while saving the event.";
                setErrorMessage(`❌ ${errorMessage}`);
            } else if (error.request) {
                setErrorMessage("❌ No response received from the server.");
            } else {
                setErrorMessage(`❌ Request error: ${error.message}`);
            }
        }
    };
    const handleEditEvent = (eventData) => {
        setNewEvent({
            ...eventData,
            bannerImage: eventData.bannerImage,
            eventBoxImage: eventData.eventBoxImage,
            ticketImage: eventData.ticketImage,
            mobileBannerImage: eventData.mobileBannerImage
        });
        setEditingEventId(eventData._id);
        setShowForm(true);
    };

    const handleRemovePriceClass = (index) => {
        const updatedPriceClasses = newEvent.priceClasses.filter((_, i) => i !== index);
        setNewEvent({ ...newEvent, priceClasses: updatedPriceClasses });
    };
    const toggleHideEvent = async (eventData) => {
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/api/events/toggle-hide/${eventData._id}`);
            fetchEvents(); // Refresh list after toggling
            console.log(`✅ Event "${eventData.title}" ${eventData.hidden ? "unhidden" : "hidden"} successfully.`);
        } catch (error) {
            console.error("❌ Error toggling hide/unhide:", error);
            alert("Failed to toggle visibility. Try again.");
        }
    };





    return (
        <div className="manage-events-container">
            <h1>Manage Events</h1>
            {showForm && (
                <form onSubmit={handleCreateOrUpdateEvent} className="event-form">
                    <label>Title:
                        <input type="text" name="title" value={newEvent.title} onChange={handleInputChange} required />
                    </label>
                    <label>Description:
                        <textarea name="description" value={newEvent.description} onChange={handleInputChange} required />
                    </label>
                    <label>Date:
                        <input
                            type="date"
                            name="date"
                            value={newEvent.date ? new Date(newEvent.date).toISOString().split("T")[0] : ""}
                            onChange={handleInputChange}
                            required
                        />
                    </label>
                    <label>Start Time:
                        <input type="time" name="startTime" value={newEvent.startTime} onChange={handleInputChange} required />
                    </label>
                    <label>End Time:
                        <input type="time" name="endTime" value={newEvent.endTime} onChange={handleInputChange} required />
                    </label>
                    <label>Location:
                        <input type="text" name="location" value={newEvent.location} onChange={handleInputChange} required />
                    </label>
                    <label>Google Maps Embed Link:
                        <input type="text" name="embedMapLink" value={newEvent.embedMapLink} onChange={handleInputChange} required />
                    </label>
                    <label>Terms & Conditions:
                        <textarea name="termsAndConditions" value={newEvent.termsAndConditions} onChange={handleInputChange} required />
                    </label>
                    <label>Status:
                        <select name="status" value={newEvent.status} onChange={handleInputChange} required>
                            <option value="Active">Active</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Sold Out">Sold Out</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </label>
                    <div className="image-upload-container">
                        <label>Web Banner Image (2160x700 JPG):</label>
                        <div
                            className="drop-zone"
                            onDrop={(e) => handleDrop(e, "bannerImage")}
                            onDragOver={(e) => e.preventDefault()}
                            onClick={() => bannerInputRef.current.click()}
                        >
                            {newEvent.bannerImage ? (
                                <img
                                    src={newEvent.bannerImage instanceof File
                                        ? URL.createObjectURL(newEvent.bannerImage)
                                            : newEvent.bannerImage}
                                    alt="Banner Preview"
                                    className="preview-image"
                                />
                            ) : (
                                <p>Drag & drop an image here or click to upload</p>
                            )}
                        </div>
                        <input
                            type="file"
                            ref={bannerInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => handleFileSelect(e, "bannerImage")}
                            accept="image/*"
                        />

                        <label>Event Box Image (700x480 JPG):</label>
                        <div
                            className="drop-zone"
                            onDrop={(e) => handleDrop(e, "eventBoxImage")}
                            onDragOver={(e) => e.preventDefault()}
                            onClick={() => eventBoxInputRef.current.click()}
                        >
                            {newEvent.eventBoxImage ? (
                                <img
                                    src={newEvent.eventBoxImage instanceof File
                                        ? URL.createObjectURL(newEvent.eventBoxImage)
                                        : newEvent.eventBoxImage?.startsWith("http")
                                            ? newEvent.eventBoxImage
                                            : `${process.env.REACT_APP_API_URL}${newEvent.eventBoxImage}`}
                                    alt="Event Box Preview"
                                    className="preview-image"
                                />

                            ) : (
                                <p>Drag & drop an image here or click to upload</p>
                            )}
                        </div>
                        <input
                            type="file"
                            ref={eventBoxInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => handleFileSelect(e, "eventBoxImage")}
                            accept="image/*"
                        />
                        <label>Ticket Image (2160x700  JPG):</label>
                        <div
                            className="drop-zone"
                            onDrop={(e) => handleDrop(e, "ticketImage")}
                            onDragOver={(e) => e.preventDefault()}
                            onClick={() => ticketInputRef.current.click()}
                        >
                            {newEvent.ticketImage ? (
                                <img
                                    src={newEvent.ticketImage instanceof File
                                        ? URL.createObjectURL(newEvent.ticketImage)
                                        : newEvent.ticketImage?.startsWith("http")
                                            ? newEvent.ticketImage
                                            : `${process.env.REACT_APP_API_URL}${newEvent.ticketImage}`}
                                    alt="Ticket Preview"
                                    className="preview-image"
                                />
                            ) : (
                                <p>Drag & drop an image here or click to upload</p>
                            )}
                        </div>
                        <input
                            type="file"
                            ref={ticketInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => handleFileSelect(e, "ticketImage")}
                            accept="image/*"
                        />
                        <label>Mobile Web Banner (500x200 JPG):</label>
                        <div
                            className="drop-zone"
                            onDrop={(e) => handleDrop(e, "mobileBannerImage")}
                            onDragOver={(e) => e.preventDefault()}
                            onClick={() => mobileBannerInputRef.current.click()}
                        >
                            {newEvent.mobileBannerImage ? (
                                <img
                                    src={newEvent.mobileBannerImage instanceof File
                                        ? URL.createObjectURL(newEvent.mobileBannerImage)
                                        : newEvent.mobileBannerImage}
                                    alt="Mobile Banner Preview"
                                    className="preview-image"
                                />
                            ) : (
                                <p>Drag & drop an image here or click to upload</p>
                            )}
                        </div>
                        <input
                            type="file"
                            ref={mobileBannerInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => handleFileSelect(e, "mobileBannerImage")}
                            accept="image/*"
                        />

                    </div>
                    <div className="price-classes">
                        <h3>Ticket Price Classes</h3>
                        {newEvent.priceClasses.map((priceClass, index) => (
                            <div key={index} className="price-class">
                                <input
                                    type="text"
                                    placeholder="Class Name"
                                    value={priceClass.name}
                                    onChange={(e) => handlePriceClassesChange(e, index, "name")}
                                    required
                                />
                                <input
                                    type="text"
                                    placeholder="Description"
                                    value={priceClass.description}
                                    onChange={(e) => handlePriceClassesChange(e, index, "description")}
                                    required
                                />
                                <input
                                    type="number"
                                    placeholder="Price (JOD)"
                                    value={priceClass.price}
                                    onChange={(e) => handlePriceClassesChange(e, index, "price")}
                                    required
                                />
                                <input
                                    type="number"
                                    placeholder="Max Tickets"
                                    value={priceClass.maxTickets}
                                    onChange={(e) => handlePriceClassesChange(e, index, "maxTickets")}
                                    required
                                />
                                <select value={priceClass.status} onChange={(e) => handlePriceClassesChange(e, index, "status")}>
                                    <option value="Available">Available</option>
                                    <option value="Sold Out">Sold Out</option>
                                </select>
                                <button type="button" onClick={() => handleRemovePriceClass(index)}>❌ Remove</button>
                            </div>
                        ))}
                        <button type="button" onClick={handleAddPriceClass}>➕ Add Price Class</button>
                    </div>
                    {errorMessage && <div className="error-message">{errorMessage}</div>}
                    <button type="submit">{editingEventId ? "Update Event" : "Create Event"}</button>
                </form>
            )}

            <table className="events-table">
                <thead>
                <tr>
                    <th>Title</th>
                    <th>Date</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Location</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {events.map(eventData => (
                    <tr key={eventData._id}>
                        <td>{eventData.title}</td>
                        <td>{new Date(eventData.date).toLocaleDateString()}</td>
                        <td>{eventData.startTime || "N/A"}</td>
                        <td>{eventData.endTime || "N/A"}</td>
                        <td>{eventData.location}</td>
                        <td>
                            <button onClick={() => handleEditEvent(eventData)} className="edit-button">Edit</button>
                            <button onClick={() => toggleHideEvent(eventData)} className="hide-button">
                                {eventData.hidden ? "Unhide" : "Hide"}
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            <button onClick={() => { setShowForm(!showForm); setEditingEventId(null); }} className="create-event-button">
                {showForm ? "Cancel" : "+ Create New Event"}
            </button>
        </div>
    );
};

export default ManageEvents;
